module.exports = __webpack_public_path__ + "img/交友.48f8dbf1.png";